import {
  restApiService,
} from '../../services/services';
import {
  handleAxiosResponse,
} from '../../util/apiHelpers';
import {
  axiosStorableError,
} from '../../util/errors';

export const GET_PLANS_REQUEST = 'app/AirPricingPage/GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'app/AirPricingPage/GET_PLANS_REQUEST_SUCCESS';
export const GET_PLANS_ERROR = 'app/AirPricingPage/GET_PLANS_REQUEST_ERROR';

export const GET_HOSTED_PAGE_REQUEST = 'app/AirPricingPage/GET_HOSTED_PAGE_REQUEST';
export const GET_HOSTED_PAGE_SUCCESS = 'app/AirPricingPage/GET_HOSTED_PAGE_SUCCESS';
export const GET_HOSTED_PAGE_ERROR = 'app/AirPricingPage/GET_HOSTED_PAGE_ERROR';

const initialState = {
  plans: [],
  isPending: false,
  error: null,
  getHostedPageInProgress: false,
  getHostedPageError: null,
};

export default function airPricingPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_PLANS_REQUEST:
      return {
        ...state,
        isPending: true,
        error: null,
      };

    case GET_PLANS_SUCCESS: {
      return {
        ...state,
        isPending: false,
        plans: payload,
      };
    }

    case GET_PLANS_ERROR:
      return {
        ...state,
        isPending: false,
        error: payload,
      };

    case GET_HOSTED_PAGE_REQUEST:
      return {
        ...state,
        getHostedPageInProgress: true,
        getHostedPageError: null,
      };

    case GET_HOSTED_PAGE_SUCCESS:
      return {
        ...state,
        getHostedPageInProgress: false,
      };

    case GET_HOSTED_PAGE_ERROR:
      return {
        ...state,
        getHostedPageInProgress: false,
        getHostedPageError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const getPlansRequest = () => ({
  type: GET_PLANS_REQUEST,
});

const getPlansSuccess = plans => ({
  type: GET_PLANS_SUCCESS,
  payload: plans,
});

const getPlansError = error => ({
  type: GET_PLANS_ERROR,
  payload: error,
});

const getHostedPageRequest = () => ({
  type: GET_HOSTED_PAGE_REQUEST,
});

const getHostedPageSuccess = () => ({
  type: GET_HOSTED_PAGE_SUCCESS,
});

const getHostedPageError = error => ({
  type: GET_HOSTED_PAGE_ERROR,
  payload: error,
});

// ================ Selectors ============= //

const $subState = state => {
  return state.AirPricingPage;
};

export const $plansState = state => {
  const subState = $subState(state);
  return {
    plans: subState.plans,
    isPending: subState.isPending,
    error: subState.error,
  };
};

export const $getHostedPageState = state => {
  const subState = $subState(state);
  return {
    inProgress: subState.getHostedPageInProgress,
    error: subState.getHostedPageError,
  };
};

// ================ Thunks ================ //

export const loadData = () => dispatch => {
  dispatch(getPlansRequest());
  return restApiService.publicInstance
    .getRaw('plans/dealers-plans')
    .then(handleAxiosResponse)
    .then(resp => {
      dispatch(getPlansSuccess(resp));
      return resp;
    })
    .catch(e => {
      dispatch(getPlansError(axiosStorableError(e)));
      throw e;
    })
  ;
};

export const getHostedPage = priceItemId => dispatch => {
  if (!priceItemId) {
    return Promise.resolve();
  }
  dispatch(getHostedPageRequest());
  return restApiService.secureInstance
    .postRaw('plans/subscribe', {
      itemPriceId: priceItemId,
    })
    .then(handleAxiosResponse)
    .then(resp => {
      dispatch(getHostedPageSuccess());
      return resp;
    })
    .catch(e => {
      dispatch(getHostedPageError(axiosStorableError(e)));
      throw e;
    })
  ;
};
